import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const audioEncoderComponent: ComponentDef = {
  id: 'audio-encoder',
  name: 'Audio Encoder',
  description: 'Encode raw waveforms or spectrograms into latent representations.',
  category: 'multimodal',
  params: [
    { name: 'seq_len', label: 'Time frames', type: 'number', default: 1024, min: 1, max: 8192, step: 1 },
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    {
      name: 'variant',
      label: 'Variant',
      type: 'select',
      default: 'whisper',
      options: [
        { label: 'Whisper (Mel + Transformer)', value: 'whisper' },
        { label: 'Generic (STFT + Linear)', value: 'generic' }
      ]
    }
  ],
  buildGraph: (params) => {
    const seq_len = Number(params.seq_len);
    const d_model = Number(params.d_model);
    const variant = String(params.variant);

    const g = new GraphBuilder();
    g.input('waveform', [seq_len]);

    if (variant === 'whisper') {
      // Whisper-style: Mel features + Transformer Encoder
      g.conv('stft', 'waveform', [seq_len, d_model], 'STFT');
      g.activation('mel', 'stft', 'Mel Filterbank');
      g.activation('log_mel', 'mel', 'Log Mel');

      // Positional encoding
      g.activation('pos_enc', 'log_mel', 'Positional Encoding');
      g.add('pos_added', 'log_mel', 'pos_enc');

      // Transformer encoder layer 1
      g.norm('norm1', 'pos_added', 'LayerNorm');
      g.linear('ff1a', 'norm1', [d_model, d_model]);
      g.activation('act1', 'ff1a', 'GELU');
      g.linear('ff1b', 'act1', [d_model, d_model]);
      g.add('res1', 'pos_added', 'ff1b');

      // Transformer encoder layer 2
      g.norm('norm2', 'res1', 'LayerNorm');
      g.linear('ff2a', 'norm2', [d_model, d_model]);
      g.activation('act2', 'ff2a', 'GELU');
      g.linear('ff2b', 'act2', [d_model, d_model]);
      g.add('res2', 'res1', 'ff2b');

      g.output('out', 'res2');
    } else {
      // Generic: STFT + pooling + linear
      g.conv('stft', 'waveform', [seq_len, d_model], 'STFT');
      g.pool('pool', 'stft', [seq_len / 4, d_model], 'time');
      g.linear('proj', 'pool', [d_model, d_model]);
      g.output('out', 'proj');
    }

    return g.build();
  }
};
